import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { mappingResultError, Result, UseCase } from '@digibricks/core';
import { AiChangeType } from '../../../../../ai';
import { HeadingStatus } from '../../domain';
export var AI_ACCEPT_HEADING_CHANGE_USE_CASE = 'AI_ACCEPT_HEADING_CHANGE_USE_CASE';
/**
 * Orchestrator use case for accepting an AI heading change.
 * - Add: saves the new heading (SaveHeadingUseCase → create).
 * - Update: saves the updated heading (SaveHeadingUseCase → update).
 * - Delete: deletes the heading (DeleteHeadingUseCase).
 */

export var AiAcceptHeadingChangeUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(AiAcceptHeadingChangeUseCase, _UseCase);

  var _super = _createSuper(AiAcceptHeadingChangeUseCase);

  function AiAcceptHeadingChangeUseCase(saveHeadingUseCase, deleteHeadingUseCase) {
    var _this;

    _classCallCheck(this, AiAcceptHeadingChangeUseCase);

    _this = _super.call(this);
    _this.saveHeadingUseCase = saveHeadingUseCase;
    _this.deleteHeadingUseCase = deleteHeadingUseCase;
    return _this;
  }

  _createClass(AiAcceptHeadingChangeUseCase, [{
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var changeType, heading, headingId, saveResult, _saveResult, _input$headings, headings, deleteResult;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                changeType = input.changeType, heading = input.heading;
                headingId = heading.id.toString();
                _context.t0 = changeType;
                _context.next = _context.t0 === AiChangeType.Add ? 5 : _context.t0 === AiChangeType.Update ? 12 : _context.t0 === AiChangeType.Delete ? 19 : 26;
                break;

              case 5:
                heading.updateStatus(HeadingStatus.New);
                _context.next = 8;
                return this.saveHeadingUseCase.execute({
                  heading: heading
                });

              case 8:
                saveResult = _context.sent;

                if (!saveResult.isFailure) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return", mappingResultError(saveResult));

              case 11:
                return _context.abrupt("break", 27);

              case 12:
                heading.updateStatus(HeadingStatus.Update);
                _context.next = 15;
                return this.saveHeadingUseCase.execute({
                  heading: heading
                });

              case 15:
                _saveResult = _context.sent;

                if (!_saveResult.isFailure) {
                  _context.next = 18;
                  break;
                }

                return _context.abrupt("return", mappingResultError(_saveResult));

              case 18:
                return _context.abrupt("break", 27);

              case 19:
                headings = (_input$headings = input.headings) !== null && _input$headings !== void 0 ? _input$headings : [];
                _context.next = 22;
                return this.deleteHeadingUseCase.execute({
                  heading: heading,
                  headings: headings
                });

              case 22:
                deleteResult = _context.sent;

                if (!deleteResult.isFailure) {
                  _context.next = 25;
                  break;
                }

                return _context.abrupt("return", mappingResultError(deleteResult));

              case 25:
                return _context.abrupt("break", 27);

              case 26:
                return _context.abrupt("break", 27);

              case 27:
                return _context.abrupt("return", Result.ok({
                  headingId: headingId
                }));

              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return AiAcceptHeadingChangeUseCase;
}(UseCase);